// import memoized from 'nano-memoize';
import percentile from '../percentile';

export default function pval(array, p) {
  return percentile(array, p);
}

// export default memoized(pval, {
//   maxArgs: 2,
// });
